import React, { useState, FC, useEffect } from "react";
import { ActivityGoalItems, ActivityGoalItemsProps } from "./ActivityGoalItems";

interface ActivityGoalsInputProps {
  value?: ActivityGoalItemsProps[];
  onChange?: (value: ActivityGoalItemsProps[]) => void;
}

export const ActivityGoalsInput: FC<ActivityGoalsInputProps> = ({ value = [], onChange }) => {
  const [model, setModel] = useState(value);

  useEffect(() => {
    setModel(value);
  }, [value]);

  const onItemChange = (i, val) => {
    model[i] = val;
    onChange && onChange([...model]);
  };

  return (
    <div style={{ display: "flex" }}>
      {model.map((x, i) => (
        <ActivityGoalItems key={x.title} value={x} onChange={(val) => onItemChange(i, val)}></ActivityGoalItems>
      ))}
    </div>
  );
};
